export default {"src":"/_next/static/media/twitter.52249f62.svg","height":18,"width":22};